import styled from 'styled-components';
import Theme from '@dagensmat/carrot/Theme';
import { Typography } from '@dagensmat/carrot/Components';
import FormLabel from '_common/components/input/FormLabel';
import { mapOptions, UnitOption } from './RadioButtons';

const RadioButtonLabel = styled(Typography).attrs(() => {
  return {
    variant: 'inputLabel'
  };
})`
  --borderWidth: ${Theme.BorderWeights.regular}px;
  --inputSize: ${Theme.Spacings.s + Theme.Spacings.xxs}px;

  display: flex;
  width: auto;
  margin-bottom: ${Theme.Spacings.xxs}px;
  padding: ${Theme.Spacings.xxs}px;

  * {
    cursor: pointer;
  }

  > div {
    margin-left: ${Theme.Spacings.xxs}px;
  }

  input {
    margin: ${Theme.Spacings.xxs / 2}px;
    width: var(--inputSize);
    height: var(--inputSize);
    border: var(--borderWidth) solid ${Theme.Colours.secondary};
    border-radius: calc(var(--inputSize) / 2);
    flex-shrink: 0;
  }

  input:disabled + div > span:first-child {
    color: ${Theme.Colours.secondary};
  }

  input:checked:before {
    content: '';
    display: block;
    background: ${Theme.Colours.black};
    width: ${Theme.Spacings.xs}px;
    height: ${Theme.Spacings.xs}px;
    margin: ${Theme.Spacings.xxs}px auto;
    border-radius: calc(var(--inputSize) / 2);
  }

  input:checked {
    border: var(--borderWidth) solid ${Theme.Colours.black};
  }
`;

export type NewRadioButtonsProps = {
  options: UnitOption[];
  currentValue: string | null | undefined;
  radioGroupName: string;
  onChange: (key: string) => void;
  labelText?: string;
};

const NewRadioButtons = ({
  options,
  currentValue,
  radioGroupName,
  onChange,
  labelText
}: NewRadioButtonsProps) => {
  const isChecked = (key: string | null): boolean => {
    return currentValue === key;
  };
  return (
    <div>
      {labelText && <FormLabel labelText={labelText} id={radioGroupName} />}
      {mapOptions(options).map(
        ({ key, value, explanationText, disabled = false }) => {
          return (
            <RadioButtonLabel key={key}>
              <input
                id={value}
                type="radio"
                name={radioGroupName}
                checked={isChecked(key)}
                onChange={() => {
                  return onChange(key);
                }}
                value={value}
                disabled={disabled}
              />
              <div>
                <Typography
                  variant={isChecked(key) ? 'paragraphBold' : 'paragraph'}
                  as={isChecked(key) ? 'strong' : 'span'}
                >
                  {value}
                </Typography>
                {explanationText && (
                  <Typography
                    variant="paragraphSmall"
                    color="secondary"
                    as="span"
                    style={{ display: 'block' }}
                  >
                    {explanationText}
                  </Typography>
                )}
              </div>
            </RadioButtonLabel>
          );
        }
      )}
    </div>
  );
};

export default NewRadioButtons;
